import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Rating,
} from "@mui/material";
import WhatsApps from "../../../assets/images/watsapp.png";
import Facebooks from "../../../assets/images/facebook.png";
import InstagramIcon from "../../../assets/images/instagram.png";
import YouTubeIcon from "../../../assets/images/youtube.png";
import LinkedInIcon from "../../../assets/images/linkdin.png";
import PinterestIcon from "../../../assets/images/pintrest.png";
import LanguageIcon from "../../../assets/images/website.png";
import LocationOnIcon from "../../../assets/images/google review.png";
import TelegramIcon from "../../../assets/images/telegram.png";
import TwitterIcon from "../../../assets/images/x.png";
import PictureAsPdfIcon from "../../../assets/images/pdf.png";
import snapchatIcon from "../../../assets/images/snapchat.png";

import mobileIcon from "../../../assets/images/mobile.png";
import skypIcon from "../../../assets/images/skype.png";
import massengerIcon from "../../../assets/images/massenger.png";
import wechatIcon from "../../../assets/images/wechat-logo-png-transparent.png";
import FaceTimeIcon from "../../../assets/images/facetime-ios.png";
import MenuIcon from "../../../assets/images/menuIcon.png";

import { useParams, useNavigate } from "react-router-dom";
import "../../../App.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SocialMedia = (props) => {
  const [rating, setRating] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [desc, setDesc] = useState("");
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (username) {
      props.viewLinkByUserName(username);
    }
  }, [username, props.viewLinkByUserName]);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCancel = () => {
    handleClose();
  };

  const handleButtonClick = (e, option) => {
    e.preventDefault();
    if (option.label === "Menu") {
      navigate(`/menu/${username}`);
    } else if (option.label === "Upi") {
      handleUpiClick();
    } else if (option.label === "Google Review") {
      if (props.client.viewLinksByUser.showAllReviews === true) {
        handleOpen();
      } else {
        let googleMapUrl = props.client.viewLinksByUser?.GoogleMaps;
        if (googleMapUrl && !googleMapUrl.startsWith("http")) {
          googleMapUrl = `https://${googleMapUrl}`;
        }
        if (googleMapUrl) {
          window.open(googleMapUrl, "_blank", "noopener,noreferrer");
        }
      }
    } else if (option.label === "Mobile" || option.label === "Face Time") {
      if (option.href) window.location.href = option.href;
    } else {
      let url = option.href;
      if (url && !url.startsWith("http")) {
        url = `https://${url}`;
      }
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }
  };

  const handleUpiClick = () => {
    const transactionId = `TXN${Date.now()}`;
    const upiLink = `upi://pay?pa=9801558387@ybl&pn=Deepak%20Kumar&tr=${transactionId}&tn=Donation&am=5000&cu=INR`;

    if (/Android/i.test(navigator.userAgent)) {
      window.location.href = upiLink;
    } else if (/iPhone|iPad/i.test(navigator.userAgent)) {
      alert("UPI deep links are not fully supported on iOS. Use a UPI app to scan a QR code.");
      window.location.href = upiLink;
    } else {
      alert("UPI payments are supported only on mobile devices with UPI apps installed.");
    }
  };

  const handleRatingChange = (event, newValue) => {
    if (newValue !== null && newValue >= 0 && newValue <= 5) {
      setRating(newValue);
      if (newValue > 3) {
        let googleMapUrl = props.client.viewLinksByUser?.GoogleMaps;
        if (googleMapUrl && !googleMapUrl.startsWith("http")) {
          googleMapUrl = `https://${googleMapUrl}`;
        }
        if (googleMapUrl) {
          window.open(googleMapUrl, "_blank", "noopener,noreferrer");
        }
      }
    } else {
      console.error("Invalid rating value:", newValue);
    }
  };

  // Helper to build social options array
  const getSocialOptions = () => {
    const data = props.client.viewLinksByUser || {};
    const options = [];

    if (props.client.view_permission === "Premium") {
      options.push({ icon: MenuIcon, label: "Menu", isImg: true });
    }
    if (data.GoogleMaps) options.push({ icon: LocationOnIcon, label: "Google Review", isImg: true });
    if (data.Instagram) options.push({ icon: InstagramIcon, label: "Instagram", href: data.Instagram, isImg: true });
    if (data.Browser) options.push({ icon: LanguageIcon, label: "Website", href: data.Browser, isImg: true });
    if (data.WhatsApp) {
      const waNum = data.WhatsApp.replace(/[^\d]/g, "");
      const finalNum = waNum.startsWith("91") ? waNum : "91" + waNum;
      options.push({ icon: WhatsApps, label: "WhatsApp", href: `https://wa.me/${finalNum}`, isImg: true });
    }
    if (data.mobile) {
      options.push({ icon: mobileIcon, label: "Mobile", href: `tel:${data.mobile.replace(/[^\d]/g, "")}`, isImg: true });
    }
    if (data.Twitter) options.push({ icon: TwitterIcon, label: "Twitter", href: data.Twitter, isImg: true });
    if (data.LinkedIn) options.push({ icon: LinkedInIcon, label: "LinkedIn", href: data.LinkedIn, isImg: true });
    if (data.Facebook) options.push({ icon: Facebooks, label: "Facebook", href: data.Facebook, isImg: true });
    if (data.massenger) options.push({ icon: massengerIcon, label: "Messenger", href: data.massenger, isImg: true });
    if (data.YouTube) options.push({ icon: YouTubeIcon, label: "YouTube", href: data.YouTube, isImg: true });
    if (data.Telegram) options.push({ icon: TelegramIcon, label: "Telegram", href: data.Telegram, isImg: true });
    if (data.Snapchat) options.push({ icon: snapchatIcon, label: "Snapchat", href: data.Snapchat, isImg: true });
    if (data.PDFDownloader) options.push({ icon: PictureAsPdfIcon, label: "PDF Downloader", href: data.PDFDownloader, isImg: true });
    if (data.Pinterest) options.push({ icon: PinterestIcon, label: "Pinterest", href: data.Pinterest, isImg: true });
    if (data.FaceTime) {
      options.push({ icon: FaceTimeIcon, label: "Face Time", href: `tel:${data.FaceTime.replace(/[^\d]/g, "")}`, isImg: true });
    }
    if (data.wechat) options.push({ icon: wechatIcon, label: "Wechat", href: data.wechat, isImg: true });
    if (data.Skype) options.push({ icon: skypIcon, label: "Skype", href: data.Skype, isImg: true });

    return options;
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 4,
        px: 2,
        overflowX: "hidden"
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "500px",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(20px)",
          borderRadius: "30px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
          overflow: "hidden",
          position: "relative",
          pb: 6,
          transition: "transform 0.3s ease",
        }}
      >
        {/* Cover Image Area */}
        <Box sx={{ position: "relative", width: "100%", height: "220px" }}>

          {props.client.viewLinksByUser?.mediaType?.toLowerCase() === "video" ? (
            <Box
              component="video"
              src={props.client.viewLinksByUser?.coverImage}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              autoPlay
              muted
              loop
              playsInline
              controls={false}
            />
          ) : props.client.viewLinksByUser?.mediaType?.toLowerCase() === "image" ? (
            <Box
              component="img"
              src={props.client.viewLinksByUser?.coverImage}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <Box
              component="video"
              src="https://firebasestorage.googleapis.com/v0/b/qrcodecustomer.firebasestorage.app/o/uploads%2FBoost%20your%20business%20visibility%20with%20just%20a%20tap%20or%20scan-2.mp4-m2ytuynfl?alt=media&token=a7daa381-c05c-41de-a3e4-8a166931c169"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              autoPlay
              muted
              loop
              playsInline
              controls={false}
            />
          )}

          {/* Profile Picture */}
          <Avatar
            src={
              props.client.viewLinksByUser?.profileImage ||
              "https://firebasestorage.googleapis.com/v0/b/qrcodecustomer.firebasestorage.app/o/uploads%2Ftapxlogobalck.png-e5rekedqt?alt=media&token=6eb1f468-ed6c-4bbd-b367-3d9e0dbd3655"
            }
            sx={{
              width: 140,
              height: 140,
              border: "4px solid rgba(255, 255, 255, 0.8)",
              position: "absolute",
              bottom: "-70px",
              left: "50%",
              transform: "translateX(-50%)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
              backgroundColor: "#fff",
              borderRadius: "50%",
              "& img": { objectFit: "cover" }
            }}
          />
        </Box>

        {/* Content Area */}
        <Box sx={{ mt: 10, px: 3, textAlign: "center", color: "#fff" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "1.8rem", sm: "2.2rem" },
              letterSpacing: "0.5px",
              mb: 1,
              background: "linear-gradient(90deg, #fff, #a5b4fc)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)"
            }}
          >
            {props.client.viewLinksByUser?.heading || "Welcome to tapx digital"}
          </Typography>

          <Typography
            sx={{
              fontSize: "1rem",
              color: "rgba(255, 255, 255, 0.8)",
              mb: 4,
              fontWeight: 400,
              letterSpacing: "0.5px"
            }}
          >
            {props.client.viewLinksByUser?.tagLine || ""}
          </Typography>

          {getSocialOptions().some(opt => opt) && (
            <Typography
              variant="subtitle1"
              sx={{
                mb: 3,
                fontWeight: 600,
                color: "#a5b4fc",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontSize: "0.8rem"
              }}
            >
              Connect With us
            </Typography>
          )}

          {/* Buttons / Icons Grid */}
          <Grid container spacing={2} justifyContent="center">
            {getSocialOptions().map((option, index) => (
              <Grid item xs={4} sm={3} key={index}>
                <Box
                  onClick={(e) => handleButtonClick(e, option)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      "& .icon-box": {
                        background: "rgba(255, 255, 255, 0.2)",
                        borderColor: "rgba(255, 255, 255, 0.5)",
                        boxShadow: "0 8px 32px rgba(255, 255, 255, 0.1)"
                      }
                    },
                  }}
                >
                  <Box
                    className="icon-box"
                    sx={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "20px",
                      background: "rgba(255, 255, 255, 0.1)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(10px)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: 1.5,
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                    }}
                  >
                    <Box
                      component="img"
                      src={option.icon}
                      alt={option.label}
                      sx={{ width: "35px", height: "35px", objectFit: "contain", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#fff",
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      opacity: 0.9,
                      letterSpacing: "0.5px"
                    }}
                  >
                    {option.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Footer Powered By */}
          <Box sx={{ mt: 8, opacity: 0.7 }}>
            <Typography variant="body2" sx={{ fontSize: "0.7rem", color: "#cbd5e1" }}>
              Powered by
            </Typography>
            <a
              href="https://tapxdigital.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Typography variant="body2" sx={{ fontWeight: 700, color: "#fff", mt: 0.5, letterSpacing: "1px" }}>
                Tapx Digital
              </Typography>
            </a>
          </Box>
        </Box>
      </Box>

      {/* Google Review Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: 24,
            padding: "20px",
            backgroundColor: "#fff", // Keep white for readability of form
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "bold",
            color: "#1e293b",
            fontSize: "1.5rem",
          }}
        >
          Leave a Review
          <Button onClick={handleCancel} sx={{ minWidth: "auto", color: "#ef4444" }}>
            <CheckCircleIcon />
          </Button>
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
              mt: 2,
            }}
          >
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              InputProps={{ style: { borderRadius: 12 } }}
            />
            <TextField
              label="Mobile Number"
              variant="outlined"
              fullWidth
              type="tel"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              InputProps={{ style: { borderRadius: 12 } }}
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{ style: { borderRadius: 12 } }}
            />
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography component="legend" fontWeight={500}>Rating</Typography>
              <Rating
                name="user-rating"
                value={rating}
                onChange={handleRatingChange}
                size="large"
              />
            </Box>
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              InputProps={{ style: { borderRadius: 12 } }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", mt: 2, pb: 2 }}>
          <Button
            onClick={() => {
              if (rating <= 3) {
                props.giveFeedBack(username, rating, name, email, mobile, desc);
                handleClose();
              } else {
                handleRatingChange(null, rating);
                handleClose();
              }
            }}
            variant="contained"
            sx={{
              borderRadius: "50px",
              padding: "12px 40px",
              fontWeight: "bold",
              textTransform: "none",
              background: "linear-gradient(135deg, #0f0c29, #302b63)",
              boxShadow: "0 4px 14px 0 rgba(0,0,0,0.39)",
            }}
          >
            Submit Review
          </Button>
        </DialogActions>
      </Dialog>

      {/* Thank You Dialog */}
      <Dialog
        open={props.client.thankyou}
        onClose={() => props.setTankYou(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: 24,
            padding: "20px",
            backgroundColor: "#fff",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            textAlign: "center"
          },
        }}
      >
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
          <CheckCircleIcon sx={{ fontSize: 60, color: "#4caf50", mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: "#333", mb: 1 }}>
            Thank You For Your Feedback!
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", mb: 3 }}>
            We truly value your input and will use it to improve our services.
          </Typography>
          <Button
            variant="contained"
            onClick={() => props.setTankYou(false)}
            sx={{
              borderRadius: "50px",
              padding: "10px 30px",
              fontWeight: "bold",
              textTransform: "none",
              background: "linear-gradient(135deg, #4caf50, #45a049)",
              boxShadow: "0 4px 14px 0 rgba(76, 175, 80, 0.39)",
            }}
          >
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SocialMedia;
